import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule} from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MenuEditorService } from '../../services/menueditor.service';
import { addIcons } from 'ionicons';
import { caretDownOutline, caretUpOutline, returnDownBackOutline, starOutline } from 'ionicons/icons';
import { Subscription } from 'rxjs';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MenuHistory } from '../../util/interfaces';

@Component({
  selector: 'app-menueditorhistory',
  templateUrl: './menueditorhistory.component.html',
  styleUrls: ['./menueditorhistory.component.scss'],
  imports: [IonicModule, TranslateModule, RouterModule, CdkAccordionModule]
})
export class MenuEditorHistoryComponent implements OnInit, OnDestroy {

  private subscription!: Subscription;
  public menuHistory: MenuHistory = {
    activeIndex: 0,
    versions: []
  };
  public openHistory = new Set<string>();

  constructor(private menuEditorSrv: MenuEditorService) {
    addIcons({ starOutline, returnDownBackOutline, caretDownOutline, caretUpOutline });
  }

  ngOnInit(): void {
    this.subscription = this.menuEditorSrv.getMenuHistory().subscribe((history) => {
      this.menuHistory = history;
    });
  }
  
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public selectMenuVersion(index: number) {
    this.menuEditorSrv.updatedActiveIndex(index);
  }

  getDate(date: Date): string {
    let result: string = "";
    const nowDate = new Date();
    const isSameDay = nowDate.getDate() === date.getDate() &&
                      nowDate.getMonth() === date.getMonth() &&
                      nowDate.getFullYear() === date.getFullYear();
    result = this.format12Hour(date);
    if (!isSameDay) {
      result += this.format12Hour(date);
    }
    return result;
  }

  public format12Hour(date: Date): string {
    const nowAbs = date.getHours() * 60 + date.getMinutes()
    const hour = Math.floor(nowAbs/60);
    const minute = nowAbs%60;

    const hh = hour % 24;
    const suffix = hh >= 12 ? "PM" : "AM";
    let h12 = hh % 12;
    h12 = h12 === 0 ? 12 : h12;
    return `${h12}:${minute.toString().padStart(2, '0')} ${suffix}`;
  }

  // return YYYY-MM-DD Date format
  private formatDateLocal(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${month} ${day} ${year}`;
  }

}
